<template>
  <div class="staff-info" :id="'obj-info-' + staff.Guid" style="visibility: visible" :class="{ active: true }">
    <table>
      <tr>
        <td><b>Исполнитель:</b></td>
        <td><b>{{ staff.Name }}</b></td>
      </tr>
      <tr>
        <td><b>Подразделение:</b></td>
        <td>{{ staff.Department }}</td>
      </tr>
      <tr v-if="staff.Work != ''">
        <td><b>Операция ТГ:</b></td>
        <td>{{ staff.Work }}</td>
      </tr>
      <tr>
        <td><b>Занятость:</b></td>
        <td>{{ staff.Status }}</td>
      </tr>
      <tr>
        <td><b>Номер рейса:</b></td>
        <td v-if="staff.Flight === ''">Нет данных</td>
        <td v-else>{{ staff.Flight === 'Нет данных' ? staff.Flight : staff.Flight + ' ' + staff.FlightDate }}</td>
      </tr>
      <tr>
        <td><b>Номера борта:</b></td>
        <td v-if="staff.Bort === ''">Нет данных</td>
        <td v-else>{{ staff.Bort }}</td>
      </tr>
      <tr v-if="staff.ArrivalAirport != 'Нет данных' && staff.ArrivalAirport != ''">
        <td><b>АП отправления:</b></td>
        <td>{{ staff.ArrivalAirport }}</td>
      </tr>
      <tr v-if="staff.DepartureAirport != 'Нет данных' && staff.DepartureAirport != ''">
        <td><b>АП прибытия:</b></td>
        <td>{{ staff.DepartureAirport }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'staffInfo',
  props: {
    staff: {
      type: Object,
      // Для объектов или массивов значения по умолчанию
      // должны возвращаться из функции
      default: function () {
        return {}
      },
    },
  },
}
</script>

<style scoped>
.staff-info {
  display: flex;
  background: #fff;
  opacity: 1;
  top: 0;
  left: 0;
  color: #494963;
  width: auto;
  padding: 8px 6px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 1.6;
  width: 300px;
}

td {
  padding: 0px 2px; /* Поля в ячейках */
  vertical-align: top; /* Выравнивание по верхнему краю ячеек */
  line-height: 15px;
  overflow-wrap: break-word;
}
</style>
